import React from 'react'
import Header from "../../../../Components/Header";
import Customer from './Customer'
import { Helmet } from 'react-helmet';
function CreateCutomer() {
  return (
        <div className='d-flex flex-column' style={{minHeight:'100vh'}}>
      <Helmet>
				<title>Customer - Create</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <Customer />
      </div>
    </div>
  )
}

export default CreateCutomer
